export default {
  computed: {
    nodeID() {
      return this.$route.params.id || this.$store.state.currentNode.id
    },
  },
}
